import ObjectTableController from "./object_table_controller"

export default class ExchangeDealsObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    listTypeFriendlyName: "deal",
    subjectType: "deal",
    enableEdit: false,
    exportPath: "/exchange/deals",
  }
}
